/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useCallback, useContext, useRef, useState } from 'react';

import {
  ContentVideosCategory,
  VideosCategoryTitle,
  VideosCategoryScroll,
  VideosCategoryContent,
  VideoCategoryIconContent,
  VideoCategoryIcon,
  VideoCategoryImageContent,
  VideoCategoryImage,
} from './styled';

import VideoButton from '../VideoButton';
import { getScaledValue } from '../../ui/styled';
import { CoreContext } from '../../context/CoreContext';

export default function VideoCategory({
  item,
  availableVideos,
  availableCatagories,
  verticalRef,
  verticalKey,
  verticalSize,
  verticalLoadMore,
}: {
  item: Record<string, unknown>;
  availableVideos?: Array<Record<string, unknown>>;
  availableCatagories?: unknown[];
  verticalRef?: React.RefObject<HTMLElement>;
  verticalKey?: number;
  verticalSize?: number;
  verticalLoadMore?: () => void;
}) {
  const sliderRef = useRef<HTMLElement>(null);
  const { setCurrentVideo } = useContext(CoreContext);

  const CARD_WIDTH = getScaledValue(127);
  const modulesMargin = getScaledValue(12);

  const categoryVideos = availableVideos?.filter(
    (fit: Record<string, unknown>) => fit.category_id === item.id,
  );

  const pageSize = 8;
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  let timerMore: ReturnType<typeof setTimeout> | undefined = useRef<
    ReturnType<typeof setTimeout> | undefined
  >(undefined).current;
  let timerMoreAction: ReturnType<typeof setTimeout> | undefined = useRef<
    ReturnType<typeof setTimeout> | undefined
  >(undefined).current;

  const handleArrowPress = (direction: string, key: number) => {
    console.log('SLID IN', direction, key);

    const focusSlider = (nextSlide: number) => {
      if (sliderRef.current) {
        const value = (CARD_WIDTH + modulesMargin) * nextSlide;
        sliderRef.current.style.left = `-${value}px`;
      }
    };

    const focusSliderVertical = (nextSlide: number) => {
      if (verticalRef.current) {
        const value = getScaledValue(148) * nextSlide;
        verticalRef.current.style.top = `-${value}px`;
      }
    };

    switch (direction) {
      case 'right': {
        const nextSlide = Number(key);
        if (nextSlide + 1 >= page * pageSize) {
          loadMore();
        }
        if (nextSlide > item?.videos?.length) return;
        return focusSlider(nextSlide);
      }
      case 'left': {
        const nextSlide = Number(key) - 1;
        if (nextSlide < 0) return;
        return focusSlider(nextSlide);
      }
      case 'down': {
        const nextSlide = Number(verticalKey) + 1;
        if (nextSlide + 1 >= verticalSize) {
          verticalLoadMore();
        }
        if (nextSlide > availableCatagories.length) return;
        return focusSliderVertical(nextSlide);
      }
      case 'up': {
        const nextSlide = Number(verticalKey) - 1;
        if (nextSlide < 0) return;
        return focusSliderVertical(nextSlide);
      }
      default:
        return;
    }
  };

  const loadMore = () => {
    if (item?.videos?.length >= pageSize * page) {
      clearTimeout(timerMoreAction);
      timerMoreAction = setTimeout(() => {
        clearTimeout(timerMore);
        setLoading(true);
        console.log('Handle More');
        timerMore = setTimeout(() => {
          setPage(page + 1);
          setLoading(false);
        }, 5000);
      }, 1500);
    }
  };
  // console.log(item)

  return (
    <>
      <ContentVideosCategory>
        <VideosCategoryTitle>{item.title}</VideosCategoryTitle>

        <VideosCategoryContent ref={sliderRef}>
          {!item.image ? (
            <>
              {!item.icon ? null : (
                <VideoCategoryIconContent>
                  <VideoCategoryIcon {...item.icon} />
                </VideoCategoryIconContent>
              )}
            </>
          ) : (
            <VideoCategoryImageContent>
              <VideoCategoryImage source={item.image} />
            </VideoCategoryImageContent>
          )}

          {(item?.videos as Array<Record<string, unknown>>)
            ?.slice(0, page * pageSize)
            ?.map((mit: Record<string, unknown>, key: number) => (
              <VideoButton
                key={`${key}`}
                item={mit}
                onArrowPress={(a: string) => handleArrowPress(a, key)}
                onEnterPress={() => setCurrentVideo(mit)}
                onPress={() => setCurrentVideo(mit)}
                spaced
              />
            ))}

          {loading ? <VideoButton loading /> : null}
        </VideosCategoryContent>
      </ContentVideosCategory>
    </>
  );
}
